class EventTracker {
  private TRACK_EVENT_NAME = 'trackBook24Event';

  public dispatchEvent(eventName: string, payload: any): void {
    const event = new CustomEvent(this.TRACK_EVENT_NAME, { detail: { eventName, payload } });
    window.dispatchEvent(event);
  }
}

export default new EventTracker();
